import { FeatureFlagOverride } from "generated-graphql/graphql";

type ChemicalProgramEnablementInput = {
  chemicalFeatureFlagOverride: FeatureFlagOverride | null | undefined;
  isTenantTierIIModuleEnabled: boolean;
};

export function isChemicalProgramEffectivelyEnabled({
  chemicalFeatureFlagOverride,
  isTenantTierIIModuleEnabled,
}: ChemicalProgramEnablementInput): boolean {
  if (chemicalFeatureFlagOverride === FeatureFlagOverride.Enabled) return true;
  if (chemicalFeatureFlagOverride === FeatureFlagOverride.Inherit)
    return isTenantTierIIModuleEnabled;
  return false;
}
